import React from "react";
import "./btn-transparent.scss";
import PropTypes from "prop-types";
import { FaFolder } from "react-icons/fa";

const BtnTransparent = (props) => {
  return (
    <button className="btn-transparent" onClick={props.btnAction}>
      {props.btnTexte}
      {props.children}
      <FaFolder />
    </button>
  );
};

BtnTransparent.propTypes = {
  btnAction: PropTypes.func,
  btnTexte: PropTypes.string,
  children: PropTypes.any,
};

export default BtnTransparent;
